import * as ww from '@wecom/jssdk';
window.wecom = {}
wecom.ww = ww;

wecom.get_auto_register_js_api_list = function () {
	return ["scanQRCode"];
}

wecom.ensure_register = function (options) {
	const jsApiList = Array.isArray(options?.js_api_list) && options.js_api_list.length
		? options.js_api_list
		: wecom.get_auto_register_js_api_list();
	const url = String(options?.url || window.location.href || "").split("#")[0];

	return new Promise((resolve, reject) => {
		frappe.call({
			method: "wecom.api.get_public_jssdk_config",
			args: {
				url,
				js_api_list: JSON.stringify(jsApiList),
			},
			callback: function (r) {
				if (!r.message) {
					reject(new Error(__("Getting Signature Failed")));
					return;
				}
				wecom.jssdk_config = r.message;
				wecom.ww.register({
					debug: false,
					corpId: wecom.jssdk_config.corpId,
					agentId: wecom.jssdk_config.agentId,
					jsApiList,
					getConfigSignature: (signatureUrl) => {
						return new Promise((resolveSignature, rejectSignature) => {
							frappe.call({
								method: "wecom.api.get_config_signature",
								args: { url: String(signatureUrl || "").split("#")[0] },
								callback: function (sigRes) {
									if (sigRes.message) {
										resolveSignature(sigRes.message);
									} else {
										rejectSignature(new Error(__("Getting Signature Failed")));
									}
								},
							});
						});
					},
					onConfigSuccess: (res) => resolve(res),
					onConfigFail: (err) => reject(err),
				});
			},
		});
	});
}

wecom.get_login_debug = function () {
	try {
		return wecom.is_truthy_param("login_debug");
	} catch (e) {
		return false;
	}
}

wecom.get_search_param = function (name) {
	try {
		const params = new URLSearchParams(location.search || "");
		return params.get(name);
	} catch (e) {
		return null;
	}
}

wecom.is_truthy_param = function (name) {
	const v = String(wecom.get_search_param(name) || "").toLowerCase();
	return v === "1" || v === "true" || v === "yes";
}

wecom.should_show_local_login = function () {
	return wecom.is_truthy_param("show_local");
}

wecom.should_hide_official_login = function () {
	return Boolean(wecom.config?.hide_official_login)
		&& !wecom.config?.developer_mode
		&& !wecom.should_show_local_login();
}

wecom.t = function (key, fallback) {
	return (
		wecom.config?.labels?.[key]
		|| __(fallback || key)
		|| fallback
		|| key
	);
}

wecom.get_login_callback_url = function () {
	const callbackPath = "/api/method/wecom.api.wecom_login";
	try {
		const configured = new URL(wecom.config?.callback_url || "", window.location.origin);
		if (configured.origin === window.location.origin && configured.pathname === callbackPath) {
			return configured.href;
		}
	} catch (e) {
		// Fall back to the current page origin when the backend URL is invalid.
	}
	return new URL(callbackPath, window.location.origin).href;
}

wecom.apply_auth_tabs_inline_styles = function (hub) {
	const shellEl = document.getElementById(hub?.shellId || "frappe-login-auth-shell");
	const tabsEl = document.getElementById(hub?.tabsId || "frappe-login-sso-tabs");
	const compactMode = window.matchMedia ? window.matchMedia("(max-width: 480px)").matches : window.innerWidth <= 480;
	if (shellEl) {
		Object.assign(shellEl.style, {
			// Card already has padding; keep tabs flush under the head on redesigned login.
			padding: "12px 0 0",
		});
	}
	if (tabsEl) {
		Object.assign(tabsEl.style, {
			display: "flex",
			flexFlow: "row nowrap",
			alignItems: "center",
			justifyContent: "stretch",
			gap: "4px",
			width: "100%",
			boxSizing: "border-box",
			padding: "4px",
			marginBottom: "10px",
			borderRadius: "999px",
			background: "var(--control-bg, #f3f5f7)",
		});
	}

	document.querySelectorAll(".frappe-login-auth-shell .frappe-login-sso-tab").forEach((tabEl) => {
		const isActive = tabEl.classList.contains("is-active");
		const hasIcon = Boolean(tabEl.querySelector("img, svg"));
		const labelEl = Array.from(tabEl.children).find((el) => el.tagName === "SPAN");
		Object.assign(tabEl.style, {
			flex: "1 1 auto",
			width: "",
			minWidth: "0",
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			gap: compactMode && hasIcon ? "0" : "4px",
			padding: compactMode && hasIcon ? "8px" : "8px 10px",
			border: "none",
			borderRadius: "999px",
			background: isActive ? "var(--card-bg, #fff)" : "transparent",
			color: isActive ? "var(--text-color, #36414c)" : "var(--text-muted, #6c7680)",
			fontSize: "13px",
			lineHeight: "1",
			textAlign: "center",
			whiteSpace: "nowrap",
			userSelect: "none",
			cursor: "pointer",
			appearance: "none",
			WebkitAppearance: "none",
			boxShadow: isActive ? "0 1px 2px rgba(0, 0, 0, 0.08)" : "none",
			outline: "none",
			font: "inherit",
			overflow: "hidden",
		});
		tabEl.querySelectorAll("img, svg").forEach((iconEl) => {
			Object.assign(iconEl.style, {
				width: "1rem",
				height: "1rem",
				objectFit: "contain",
				verticalAlign: "text-bottom",
				flex: "0 0 auto",
			});
		});
		if (labelEl) {
			Object.assign(labelEl.style, {
				display: compactMode && hasIcon ? "none" : "block",
				minWidth: "0",
				maxWidth: "100%",
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				flex: "0 1 auto",
			});
		}
	});
}

wecom.get_login_card_el = function () {
	return (
		document.querySelector("section.for-login .login-content.page-card")
		|| document.querySelector("section.for-login .page-card")
		|| document.querySelector(".login-content.page-card")
		|| document.querySelector(".page-card")
		|| null
	);
}

wecom.get_login_form_el = function () {
	return (
		document.querySelector("section.for-login > .login-content.page-card > form.form-login")
		|| document.querySelector("section.for-login .login-content.page-card > form.form-signin")
		|| document.querySelector("section.for-login form.form-login")
		|| document.querySelector("form.form-login")
		|| null
	);
}

wecom.get_login_head_el = function (cardEl) {
	const card = cardEl || wecom.get_login_card_el();
	if (!card) return null;
	return card.querySelector(".page-card-head") || null;
}

/** Insert auth shell after page-card-head so tabs stay below logo/title on redesigned login. */
wecom.insert_auth_shell = function (cardEl, shellEl) {
	if (!cardEl || !shellEl) return;
	const headEl = wecom.get_login_head_el(cardEl);
	if (headEl) {
		headEl.insertAdjacentElement("afterend", shellEl);
		return;
	}
	const formEl = wecom.get_login_form_el();
	if (formEl && formEl.parentElement === cardEl) {
		cardEl.insertBefore(shellEl, formEl);
		return;
	}
	cardEl.prepend(shellEl);
}

/** Place SSO hub after the native login form (before sign-up message when present). */
wecom.insert_auth_hub = function (cardEl, hubEl, formEl) {
	if (!cardEl || !hubEl) return;
	if (formEl && formEl.parentElement === cardEl) {
		formEl.insertAdjacentElement("afterend", hubEl);
		return;
	}
	const signupEl = cardEl.querySelector(".sign-up-message");
	if (signupEl) {
		cardEl.insertBefore(hubEl, signupEl);
		return;
	}
	cardEl.appendChild(hubEl);
}

wecom.get_local_provider_meta = function () {
	const logoEl = document.querySelector("section.for-login .page-card-head .app-logo")
		|| document.querySelector(".page-card-head .app-logo");
	const titleEl = document.querySelector("section.for-login .page-card-head h4")
		|| document.querySelector(".page-card-head h4");
	const rawTitle = (titleEl?.textContent || "").trim();
	let title = rawTitle
		.replace(/^Login to\s+/i, "")
		.replace(/^登录到/, "")
		.trim();

	// Redesigned login uses a generic "Sign In" title; use Website/System Settings app_name.
	if (!title || /^(sign in|登录)$/i.test(title)) {
		title = wecom.config?.app_name || "Frappe";
	}

	return {
		iconUrl: logoEl?.getAttribute("src") || "",
		title: title || "Frappe",
	};
}

wecom.has_local_login_provider = function () {
	const formEl = wecom.get_login_form_el();
	if (!formEl) return false;

	return Boolean(
		formEl.querySelector("#login_email")
		|| formEl.querySelector("#login_password")
		|| formEl.querySelector(".btn-ldap-login")
	);
}

/** True when hub uses auth-shell layout (tabs under logo; separate from panels). */
wecom.is_auth_tabs_hub = function (hub) {
	return Boolean(hub && hub.shellId && typeof hub.ensureDom === "function" && typeof hub.registerProvider === "function");
}

/**
 * Adopt providers from ding's legacy hub (tabs nested inside hub) into auth-tabs layout.
 * Ding often boots first and would otherwise leave provider tabs / WeCom mode UI misplaced.
 */
wecom.adopt_legacy_sso_hub_providers = function (authHub, legacyHub) {
	if (!wecom.is_auth_tabs_hub(authHub) || !legacyHub?.providers?.size) return;

	const dom = authHub.ensureDom();
	if (!dom?.tabsEl || !dom?.panelsEl) return;

	const legacyTabsParent = document.getElementById(legacyHub.tabsId);
	const legacyPanelsParent = document.getElementById(legacyHub.panelsId);

	for (const [key, provider] of legacyHub.providers.entries()) {
		if (!key || authHub.providers.has(key) || provider?.isNativeForm) continue;

		const tabEl = provider.tabEl;
		const panelEl = provider.panelEl;
		if (tabEl && tabEl.parentElement !== dom.tabsEl) {
			dom.tabsEl.appendChild(tabEl);
		}
		if (panelEl && panelEl.parentElement !== dom.panelsEl) {
			dom.panelsEl.appendChild(panelEl);
		}

		// Rebind click to auth hub show (legacy listeners still call legacy show).
		if (tabEl) {
			const nextTab = tabEl.cloneNode(true);
			nextTab.addEventListener("click", () => authHub.show(key));
			tabEl.replaceWith(nextTab);
			provider.tabEl = nextTab;
		}

		authHub.providers.set(key, {
			key,
			tabEl: provider.tabEl,
			panelEl,
			priority: provider.priority || 0,
			onShow: provider.onShow || null,
			isNativeForm: false,
		});
	}

	// Drop empty legacy tab/panel wrappers left inside form/hub.
	if (legacyTabsParent && legacyTabsParent !== dom.tabsEl && !legacyTabsParent.children.length) {
		legacyTabsParent.remove();
	}
	if (
		legacyPanelsParent
		&& legacyPanelsParent !== dom.panelsEl
		&& legacyPanelsParent.parentElement
		&& legacyPanelsParent.parentElement.id === authHub.hubId
		&& legacyPanelsParent !== dom.panelsEl
	) {
		// panels moved; leave dom.panelsEl as source of truth
	}

	const staleHub = document.getElementById(authHub.hubId);
	if (staleHub && dom.hubEl && staleHub !== dom.hubEl) {
		staleHub.remove();
	}

	authHub.updateTabsVisibility();
	const preferred =
		(legacyHub.activeKey && authHub.providers.has(legacyHub.activeKey) && legacyHub.activeKey)
		|| authHub.activeKey
		|| (authHub.providers.has(authHub.localKey) ? authHub.localKey : null)
		|| [...authHub.providers.keys()][0];
	if (preferred) authHub.show(preferred);

	// Ding keeps a local reference to the legacy hub object; forward calls after upgrade.
	legacyHub.shellId = authHub.shellId;
	legacyHub.ensureDom = (...args) => authHub.ensureDom(...args);
	legacyHub.show = (...args) => authHub.show(...args);
	legacyHub.registerProvider = (...args) => authHub.registerProvider(...args);
	legacyHub.updateTabsVisibility = (...args) => authHub.updateTabsVisibility(...args);
	legacyHub.providers = authHub.providers;
	try {
		Object.defineProperty(legacyHub, "activeKey", {
			get() { return authHub.activeKey; },
			set(v) { authHub.activeKey = v; },
			configurable: true,
		});
	} catch (e) {
		legacyHub.activeKey = authHub.activeKey;
	}
}

wecom.sync_wecom_panel_visibility = function (activeKey) {
	const wrapper = document.getElementById("wecom_login_panel_wrapper");
	const modeTabs = document.getElementById("wecom_login_mode_tabs");
	const showWecom = activeKey === "wecom";
	if (wrapper) wrapper.style.display = showWecom ? "" : "none";
	if (modeTabs && !showWecom) modeTabs.style.display = "none";
}

/**
 * Ensure the login hub exposes the native username/password form as a local provider.
 * Needed when ding boots first and wecom reuses its auth hub (which has no registerLocalProvider).
 */
wecom.ensure_hub_local_provider = function (hub) {
	if (!hub || !wecom.has_local_login_provider()) return null;

	if (wecom.should_hide_official_login()) {
		const formEl = wecom.get_login_form_el();
		if (formEl) formEl.style.display = "none";
		return null;
	}

	hub.localKey = hub.localKey || "frappe";

	if (typeof hub.registerLocalProvider !== "function") {
		hub.registerLocalProvider = function () {
			const dom = typeof this.ensureDom === "function" ? this.ensureDom() : null;
			const formEl = dom?.formEl || wecom.get_login_form_el();
			const tabsEl = dom?.tabsEl || document.getElementById(this.tabsId || "frappe-login-sso-tabs");
			if (!formEl || !tabsEl) return null;
			if (this.providers?.has(this.localKey)) {
				return this.providers.get(this.localKey).panelEl;
			}

			const localMeta = wecom.get_local_provider_meta();
			const tabEl = document.createElement("button");
			tabEl.type = "button";
			tabEl.className = "frappe-login-sso-tab";
			tabEl.setAttribute("aria-label", localMeta.title || this.localKey);
			tabEl.setAttribute("title", localMeta.title || this.localKey);
			tabEl.setAttribute("aria-pressed", "false");
			if (localMeta.iconUrl) {
				const img = document.createElement("img");
				img.src = localMeta.iconUrl;
				img.alt = localMeta.title || this.localKey;
				tabEl.appendChild(img);
			}
			const label = document.createElement("span");
			label.textContent = localMeta.title || "Frappe";
			tabEl.appendChild(label);
			tabEl.addEventListener("click", () => this.show(this.localKey));
			tabsEl.insertBefore(tabEl, tabsEl.firstChild);

			formEl.classList.add("frappe-login-local-panel");
			this.providers.set(this.localKey, {
				key: this.localKey,
				tabEl,
				panelEl: formEl,
				priority: 0,
				isNativeForm: true,
			});
			if (typeof this.updateTabsVisibility === "function") {
				this.updateTabsVisibility();
			}
			return formEl;
		};
	}

	hub.registerLocalProvider();

	if (
		wecom.should_show_local_login()
		&& hub.providers?.has(hub.localKey)
		&& typeof hub.show === "function"
	) {
		hub.show(hub.localKey);
	}
	return hub.providers?.get(hub.localKey)?.panelEl || null;
}

wecom.ensure_login_sso_hub = function () {
	if (wecom.is_auth_tabs_hub(window.__frappe_login_auth_tabs)) {
		wecom.ensure_hub_local_provider(window.__frappe_login_auth_tabs);
		return window.__frappe_login_auth_tabs;
	}
	if (wecom.is_auth_tabs_hub(window.__frappe_login_sso_hub)) {
		window.__frappe_login_auth_tabs = window.__frappe_login_sso_hub;
		wecom.ensure_hub_local_provider(window.__frappe_login_sso_hub);
		return window.__frappe_login_sso_hub;
	}

	const legacyHub =
		window.__frappe_login_sso_hub
		&& typeof window.__frappe_login_sso_hub.registerProvider === "function"
		&& !wecom.is_auth_tabs_hub(window.__frappe_login_sso_hub)
			? window.__frappe_login_sso_hub
			: null;

	const hub = {
		shellId: "frappe-login-auth-shell",
		hubId: "frappe-login-sso-hub",
		tabsId: "frappe-login-sso-tabs",
		panelsId: "frappe-login-sso-panels",
		localKey: "frappe",
		activeKey: null,
		providers: new Map(),
		ensureDom() {
			const cardEl = wecom.get_login_card_el();
			const formEl = wecom.get_login_form_el();
			if (!cardEl) return null;

			cardEl.classList.add("frappe-login-auth-enabled");
			if (formEl) {
				formEl.classList.add("frappe-login-local-panel");
			}

			let shellEl = document.getElementById(this.shellId);
			if (!shellEl) {
				shellEl = document.createElement("div");
				shellEl.id = this.shellId;
				shellEl.className = "frappe-login-auth-shell";

				let tabsEl = document.getElementById(this.tabsId);
				if (!tabsEl) {
					tabsEl = document.createElement("div");
					tabsEl.id = this.tabsId;
					tabsEl.className = "frappe-login-sso-tabs";
				} else if (tabsEl.parentElement !== shellEl) {
					shellEl.appendChild(tabsEl);
				}
				if (!shellEl.contains(tabsEl)) shellEl.appendChild(tabsEl);

				wecom.insert_auth_shell(cardEl, shellEl);
			} else if (!document.getElementById(this.tabsId)) {
				const tabsEl = document.createElement("div");
				tabsEl.id = this.tabsId;
				tabsEl.className = "frappe-login-sso-tabs";
				shellEl.appendChild(tabsEl);
			}

			let hubEl = document.getElementById(this.hubId);
			if (!hubEl) {
				hubEl = document.createElement("div");
				hubEl.id = this.hubId;
				hubEl.className = "page-card-body frappe-login-sso-hub";

				let panelsEl = document.getElementById(this.panelsId);
				if (!panelsEl) {
					panelsEl = document.createElement("div");
					panelsEl.id = this.panelsId;
					panelsEl.className = "frappe-login-sso-panels";
				}
				if (!hubEl.contains(panelsEl)) hubEl.appendChild(panelsEl);

				wecom.insert_auth_hub(cardEl, hubEl, formEl);
			} else {
				// Legacy ding hub kept tabs inside hub; move tabs out to shell.
				const nestedTabs = hubEl.querySelector(`#${this.tabsId}`);
				const shell = document.getElementById(this.shellId);
				if (nestedTabs && shell && nestedTabs.parentElement !== shell) {
					shell.appendChild(nestedTabs);
				}
				if (!document.getElementById(this.panelsId)) {
					const panelsEl = document.createElement("div");
					panelsEl.id = this.panelsId;
					panelsEl.className = "frappe-login-sso-panels";
					hubEl.appendChild(panelsEl);
				}
				if (hubEl.parentElement !== cardEl) {
					wecom.insert_auth_hub(cardEl, hubEl, formEl);
				}
			}

			wecom.apply_auth_tabs_inline_styles(this);

			return {
				cardEl,
				formEl,
				shellEl: document.getElementById(this.shellId),
				tabsEl: document.getElementById(this.tabsId),
				hubEl: document.getElementById(this.hubId),
				panelsEl: document.getElementById(this.panelsId),
			};
		},
		createTab({ key, iconUrl, title }) {
			const tabEl = document.createElement("button");
			tabEl.type = "button";
			tabEl.className = "frappe-login-sso-tab";
			tabEl.setAttribute("aria-label", title || key);
			tabEl.setAttribute("title", title || key);
			tabEl.setAttribute("aria-pressed", "false");

			if (iconUrl) {
				const img = document.createElement("img");
				img.src = iconUrl;
				img.alt = title || key;
				tabEl.appendChild(img);
			}

			if (title) {
				const label = document.createElement("span");
				label.textContent = title;
				tabEl.appendChild(label);
			}

			tabEl.addEventListener("click", () => this.show(key));
			return tabEl;
		},
		registerLocalProvider() {
			const dom = this.ensureDom();
			if (!dom) return null;
			if (!wecom.has_local_login_provider() || !dom.formEl) return null;

			const existing = this.providers.get(this.localKey);
			if (existing) return existing.panelEl;

			const localMeta = wecom.get_local_provider_meta();
			const tabEl = this.createTab({
				key: this.localKey,
				iconUrl: localMeta.iconUrl,
				title: localMeta.title,
			});
			dom.tabsEl?.appendChild(tabEl);

			this.providers.set(this.localKey, {
				key: this.localKey,
				tabEl,
				panelEl: dom.formEl,
				priority: 0,
				isNativeForm: true,
			});
			this.updateTabsVisibility();
			this.show(this.activeKey || this.localKey);
			return dom.formEl;
		},
		updateTabsVisibility() {
			const tabsEl = document.getElementById(this.tabsId);
			const shellEl = document.getElementById(this.shellId);
			if (!tabsEl || !shellEl) return;
			const shouldShowTabs = this.providers.size > 1;
			tabsEl.style.display = shouldShowTabs ? "" : "none";
			shellEl.style.display = shouldShowTabs ? "" : "none";
		},
		show(key) {
			const dom = this.ensureDom();
			if (!dom || !this.providers.has(key)) return;

			this.activeKey = key;
			const showLocal = key === this.localKey && Boolean(this.providers.get(this.localKey)?.isNativeForm && dom.formEl);
			dom.cardEl.classList.toggle("frappe-login-auth-external", !showLocal);
			if (dom.formEl) {
				dom.formEl.style.display = showLocal ? "" : "none";
			}
			if (dom.hubEl) {
				dom.hubEl.style.display = showLocal ? "none" : "block";
			}

			for (const [providerKey, provider] of this.providers.entries()) {
				const isActive = providerKey === key;
				if (!provider.isNativeForm && provider.panelEl) {
					provider.panelEl.style.display = isActive ? "" : "none";
				}
				if (provider.tabEl) {
					provider.tabEl.classList.toggle("is-active", isActive);
					provider.tabEl.setAttribute("aria-pressed", isActive ? "true" : "false");
				}
				if (isActive && typeof provider.onShow === "function") {
					provider.onShow();
				}
			}
			wecom.sync_wecom_panel_visibility(key);
			wecom.apply_auth_tabs_inline_styles(this);
		},
		registerProvider({ key, iconUrl, title, priority = 0, onShow = null }) {
			if (!key) return null;
			if (
				!this.providers.has(this.localKey)
				&& wecom.has_local_login_provider()
				&& !wecom.should_hide_official_login()
			) {
				this.registerLocalProvider();
			}
			const dom = this.ensureDom();
			if (!dom || !dom.tabsEl || !dom.panelsEl) return null;

			if (this.providers.has(key)) {
				const existing = this.providers.get(key);
				if (existing) {
					existing.priority = priority;
					existing.onShow = onShow;
					return existing.panelEl;
				}
			}

			const tabEl = this.createTab({ key, iconUrl, title });
			const panelEl = document.createElement("div");
			panelEl.id = `frappe-login-sso-panel-${key}`;
			panelEl.style.display = "none";

			dom.tabsEl.appendChild(tabEl);
			dom.panelsEl.appendChild(panelEl);

			this.providers.set(key, {
				key,
				tabEl,
				panelEl,
				priority,
				onShow,
				isNativeForm: false,
			});
			this.updateTabsVisibility();
			wecom.apply_auth_tabs_inline_styles(this);

			let nextKey = this.activeKey || (this.providers.has(this.localKey) ? this.localKey : key);
			const current = this.providers.get(nextKey);
			if (!current || priority > (current.priority || 0)) {
				nextKey = key;
			}
			if (wecom.should_show_local_login() && this.providers.has(this.localKey)) {
				nextKey = this.localKey;
			}

			this.show(nextKey);
			return panelEl;
		},
	};

	window.__frappe_login_auth_tabs = hub;
	window.__frappe_login_sso_hub = hub;

	if (legacyHub) {
		wecom.adopt_legacy_sso_hub_providers(hub, legacyHub);
	}

	wecom.ensure_hub_local_provider(hub);
	return hub;
}

wecom.ensure_login_provider_panel = function () {
	const hub = wecom.ensure_login_sso_hub();
	const priority = wecom.iswechat() ? 40 : 20;
	const panel = hub.registerProvider({
		key: "wecom",
		iconUrl: "/assets/wecom/icons/wecom.svg",
		title: wecom.t("provider_title", "Wecom"),
		priority: priority,
		onShow: () => wecom.ensure_qr_panel(),
	});
	// ding's registerProvider may re-select wecom by priority; re-apply show_local last.
	if (
		wecom.should_show_local_login()
		&& hub.providers?.has(hub.localKey || "frappe")
		&& typeof hub.show === "function"
	) {
		hub.show(hub.localKey || "frappe");
	}
	return panel;
}

wecom.iswechat = function () {
	const ua = navigator.userAgent.toLowerCase();
	return ua.indexOf('micromessenger') !== -1;
}

wecom.make_buttons = function () {
	wecom.init_login();
}

wecom.init_login = function (login_debug) {
	login_debug = login_debug ?? wecom.get_login_debug();
	const cfg = wecom.config || {};
	const canUseWecom = cfg.is_valid || cfg.developer_mode || login_debug;
	const hasOtp = cfg.enable_otp_login && (cfg.enabled || cfg.developer_mode || login_debug);
	const hasQr = canUseWecom && !wecom.iswechat() && !frappe.is_mobile();

	if (!hasQr && !hasOtp) {
		if (wecom.iswechat() && canUseWecom) {
			wecom.make_wechat_login_btn();
		}
		return;
	}

	if (wecom.iswechat() && canUseWecom) {
		wecom.make_wechat_login_btn();
		if (hasOtp) {
			const panel = wecom.ensure_login_provider_panel();
			wecom.make_wecom_login_panel_wrapper();
			const qrView = document.getElementById("wecom_login_qr_view");
			if (qrView) qrView.style.display = "none";
			wecom.make_otp_in_panel(panel, { defaultMode: "otp", showToggle: false });
		}
		return;
	}

	const panel = wecom.ensure_login_provider_panel();
	if (hasQr || hasOtp) {
		wecom.make_wecom_login_panel_wrapper();
	}
	if (hasQr) {
		wecom.prepare_qr_panel(panel);
	} else {
		const qrView = document.getElementById("wecom_login_qr_view");
		if (qrView) qrView.style.display = "none";
	}
	if (hasOtp) {
		wecom.make_otp_in_panel(panel, {
			defaultMode: hasQr ? "qr" : "otp",
			showToggle: hasQr,
		});
	} else if (hasQr) {
		wecom.ensure_qr_panel();
	}
}


wecom.make_wechat_login_btn = function () {
	let social_login_el = wecom.make_custom_social_login_wrapper()
	if (social_login_el) {
		wecom.add_login_button(social_login_el);
	}
}

wecom.make_custom_social_login_wrapper = function () {
	const container = wecom.ensure_login_provider_panel();
	if (!container) return null;

	let social_login_el = document.getElementById('wecom_custom_social_login');
	if (!social_login_el) {
		container.insertAdjacentHTML('beforeend', `
				<div id="wecom_custom_social_login" class="social-login-buttons" style="">
				</div>
			`);
		return document.getElementById('wecom_custom_social_login');
	}
	return social_login_el;
}

wecom.normalize_login_card_layout = function () {
	const pageCard = document.querySelector("section.for-login .login-content.page-card");
	const hub = document.getElementById("frappe-login-sso-hub");
	const wrapper = document.getElementById("wecom_login_panel_wrapper");
	const qrView = document.getElementById("wecom_login_qr_view");
	const shell = document.querySelector(".wecom-login-qr-shell");
	const modeTabs = document.getElementById("wecom_login_mode_tabs");

	// Keep QR / mode tabs as wide as the native form fields (card content width).
	if (hub) {
		hub.style.width = "100%";
		hub.style.maxWidth = "none";
		hub.style.boxSizing = "border-box";
	}

	[wrapper, qrView, shell, modeTabs].forEach((el) => {
		if (!el) return;
		el.style.width = "100%";
		el.style.maxWidth = "none";
		el.style.marginLeft = "0";
		el.style.marginRight = "0";
		el.style.boxSizing = "border-box";
	});

	if (pageCard) {
		// Do not override Frappe login card width; only ensure full content width usage.
		pageCard.style.boxSizing = "border-box";
	}
}

wecom.sync_qr_shell_height = function () {
	const shell = document.querySelector(".wecom-login-qr-shell");
	const panel = document.getElementById("wecom_login_panel");
	const iframe = panel?.querySelector("iframe");
	if (!shell) return;

	// Prefer CSS aspect-ratio full-width layout; only bump height if iframe needs more room.
	shell.style.width = "100%";
	shell.style.maxWidth = "none";
	shell.style.height = "";
	const shellWidth = Math.round(shell.getBoundingClientRect().width || shell.clientWidth || 0);
	const iframeHeight = Math.round(iframe?.getBoundingClientRect().height || iframe?.clientHeight || 0);
	if (shellWidth && iframeHeight > shellWidth * 1.05) {
		shell.style.height = `${iframeHeight}px`;
	}
}

wecom.make_wecom_login_panel_wrapper = function () {
	const container = wecom.ensure_login_provider_panel();
	if (!container) return null;

	let wrapper = document.getElementById("wecom_login_panel_wrapper");
	const needsRebuild = !wrapper || !document.getElementById("wecom_login_otp_view");
	if (needsRebuild) {
		wecom._qr_initialized = false;
		wrapper?.remove();
		container.insertAdjacentHTML("beforeend", `
			<div id="wecom_login_panel_wrapper" class="wecom-login-panel">
				<div id="wecom_login_mode_tabs" class="wecom-login-mode-tabs" style="display:none;" role="tablist" aria-label="${wecom.t("wecom_login", "WeCom Login")}">
					<button type="button" role="tab" class="wecom-mode-tab is-active" data-mode="qr" aria-selected="true">
						${wecom.t("qr_code_login", "QR Code Login")}
					</button>
					<button type="button" role="tab" class="wecom-mode-tab" data-mode="otp" aria-selected="false">
						${wecom.t("verification_code_login", "Verification Code Login")}
					</button>
				</div>
				<div class="wecom-login-viewport">
					<div id="wecom_login_qr_view" class="wecom-login-view" role="tabpanel">
						<div class="wecom-login-qr-shell">
						<div id="wecom_login_panel"></div>
						</div>
					</div>
					<div id="wecom_login_otp_view" class="wecom-login-view" role="tabpanel" hidden></div>
				</div>
			</div>
		`);
	}
	wecom.normalize_login_card_layout();
	return document.getElementById("wecom_login_panel");
}

wecom.prepare_qr_panel = function () {
	wecom.make_wecom_login_panel_wrapper();
	const hub = window.__frappe_login_sso_hub;
	if (!hub || hub.activeKey === "wecom" || hub.providers.size <= 1) {
		wecom.ensure_qr_panel();
	}
}

wecom.ensure_qr_panel = function () {
	if (wecom._qr_initialized) return;
	const el = document.getElementById("wecom_login_panel");
	if (!el || el.dataset.wecomQrReady) return;
	if (wecom.config && wecom.config.corpid && wecom.config.agentid && wecom.config.base_url) {
		wecom.createPanel("#wecom_login_panel");
		wecom._qr_initialized = true;
		el.dataset.wecomQrReady = "1";
		setTimeout(() => {
			wecom.fix_qr_iframe_size();
			wecom.observe_qr_panel_mutation();
			wecom.observe_qr_iframe_size();
		}, 0);
		setTimeout(() => {
			wecom.fix_qr_iframe_size();
		}, 200);
		setTimeout(() => {
			wecom.fix_qr_iframe_size();
		}, 500);
		setTimeout(() => {
			wecom.fix_qr_iframe_size();
		}, 1200);
	}
}

wecom.fix_qr_iframe_size = function () {
	const panel = document.getElementById("wecom_login_panel");
	const iframe = panel?.querySelector("iframe");
	if (!panel) return;

	wecom.normalize_login_card_layout();
	panel.style.display = "block";
	panel.style.position = "absolute";
	panel.style.inset = "0";
	panel.style.transform = "none";
	panel.style.width = "100%";
	panel.style.height = "100%";
	panel.style.maxWidth = "none";
	panel.style.minHeight = "0";
	if (!iframe) return;
	iframe.setAttribute("scrolling", "no");
	iframe.style.width = "100%";
	iframe.style.height = "100%";
	iframe.style.maxWidth = "100%";
	iframe.style.maxHeight = "100%";
	iframe.style.minHeight = "100%";
	iframe.style.border = "0";
	wecom.sync_qr_shell_height();
}

wecom.observe_qr_panel_mutation = function () {
	const panel = document.getElementById("wecom_login_panel");
	if (!panel || typeof MutationObserver === "undefined") return;
	if (wecom._qr_panel_mutation_observer_target === panel) return;

	wecom._qr_panel_mutation_observer?.disconnect();
	wecom._qr_panel_mutation_observer = new MutationObserver(() => {
		wecom.fix_qr_iframe_size();
	});
	wecom._qr_panel_mutation_observer.observe(panel, {
		childList: true,
		subtree: true,
	});
	wecom._qr_panel_mutation_observer_target = panel;
}

wecom.observe_qr_iframe_size = function () {
	const shell = document.querySelector(".wecom-login-qr-shell");
	if (!shell || typeof ResizeObserver === "undefined") return;
	if (wecom._qr_resize_observer_target === shell) return;
	wecom._qr_resize_observer?.disconnect();
	wecom._qr_resize_observer = new ResizeObserver(() => wecom.fix_qr_iframe_size());
	wecom._qr_resize_observer.observe(shell);
	wecom._qr_resize_observer_target = shell;
}

wecom.bind_mode_tabs = function () {
	const modeTabs = document.getElementById("wecom_login_mode_tabs");
	if (!modeTabs || modeTabs.dataset.bound) return;
	modeTabs.dataset.bound = "1";
	modeTabs.querySelectorAll(".wecom-mode-tab").forEach((tab) => {
		tab.addEventListener("click", () => wecom.set_wecom_login_mode(tab.dataset.mode));
	});
}

wecom.set_wecom_login_mode = function (mode) {
	const qrView = document.getElementById("wecom_login_qr_view");
	const otpView = document.getElementById("wecom_login_otp_view");
	const modeTabs = document.getElementById("wecom_login_mode_tabs");
	if (!qrView || !otpView) return;

	const showQr = mode === "qr";
	qrView.hidden = !showQr;
	otpView.hidden = showQr;

	if (modeTabs) {
		modeTabs.querySelectorAll(".wecom-mode-tab").forEach((tab) => {
			const isActive = tab.dataset.mode === mode;
			tab.classList.toggle("is-active", isActive);
			tab.setAttribute("aria-selected", isActive ? "true" : "false");
		});
	}

	if (showQr) {
		wecom.ensure_qr_panel();
		setTimeout(() => {
			wecom.fix_qr_iframe_size();
		}, 0);
		setTimeout(() => {
			wecom.fix_qr_iframe_size();
		}, 200);
	}
}

wecom.add_login_button = function (social_login_el) {
	const params = new URLSearchParams(location.search);
	const redirectTo = params.get('redirect-to');

	let href = `/api/method/wecom.api.redirect_with_auth?url=${redirectTo || '/'}`
	let svg = `/assets/wecom/icons/wecom.svg`
	social_login_el.insertAdjacentHTML('beforeend', `
			<div class="login-button-wrapper">
				<a href="${href}" 
				class="btn btn-sm btn-default btn-block btn-login my-2" ${wecom.config.developer_mode ? "style='background:gold;'" : ""}>
					<img src="${svg}" style="height:16px;width:auto;" alt="${wecom.t("provider_title", "Wecom")}">
					${wecom.t("sign_in_with_wechat", "Sign in with Wechat")}
				</a>
			</div>
		`);
}

wecom.createPanel = function (el_selector) {
	wecom.wwLogin = wecom.ww.createWWLoginPanel({
		el: el_selector || '#wecom_login_panel',
		params: {
			login_type: 'CorpApp',
			appid: wecom.config.corpid,
			agentid: wecom.config.agentid,
			redirect_uri: wecom.get_login_callback_url(),
			state: wecom.config.disable_signup ? wecom.config.web_redirect_url || '/me' : wecom.config.web_redirect_url || '/app',
			redirect_type: 'top',
			panel_size: 'small',
			lang: 'zh',
		},
		onCheckWeComLogin({ isWeComLogin }) {
			return Boolean(isWeComLogin);
		},
		onLoginSuccess({ code }) {
			frappe.call({
				method: 'wecom.api.wecom_login',
				args: {
					code: code,
				},
				callback: function (r) {
					if (r.message) {
						wecom.code = code
					}
				}
			})
		},
		onLoginFail(err) {
			return err;
		},
	})
}

wecom.make_otp_in_panel = function (panelEl, options = {}) {
	if (!panelEl) return;

	wecom.make_wecom_login_panel_wrapper();
	const otpView = document.getElementById("wecom_login_otp_view");
	if (!otpView) return;
	if (document.getElementById("wecom_otp_login_form")) return;

	const { defaultMode = "otp", showToggle = false } = options;
	const modeTabs = document.getElementById("wecom_login_mode_tabs");
	const params = new URLSearchParams(location.search || "");
	const redirectTo = params.get("redirect-to") || "/app";
	const wecomIcon = "/assets/wecom/icons/wecom.svg";

	otpView.insertAdjacentHTML("beforeend", `
		<div id="wecom_otp_login_form" class="wecom-otp-login-form">
			<div class="page-card-body">
				<div class="wecom-otp-heading" ${showToggle ? 'style="display:none;"' : ""}>
					<img src="${wecomIcon}" alt="${wecom.t("provider_title", "Wecom")}" class="wecom-otp-heading-icon">
					<span>${wecom.t("login_with_verification_code", "Login with verification code")}</span>
				</div>
				<div class="form-group">
					<input type="text" id="wecom_otp_email" class="form-control" required
						placeholder="${wecom.t("email_or_mobile", "Email / Mobile")}" autocomplete="username">
				</div>
				<div class="form-group">
					<div class="wecom-otp-code-group">
						<input type="text" id="wecom_otp_code" class="form-control" maxlength="6"
							pattern="[0-9]{6}" inputmode="numeric" placeholder="${wecom.t("verification_code", "Verification Code")}">
						<button type="button" id="wecom_otp_send_btn" class="wecom-otp-send-btn">${wecom.t("send_code", "Send Code")}</button>
					</div>
				</div>
			</div>
			<div class="page-card-actions">
				<button type="button" id="wecom_otp_login_btn" class="btn btn-sm btn-primary btn-block btn-login">
					<span class="wecom-otp-login-btn-content">
						<img src="${wecomIcon}" alt="${wecom.t("provider_title", "Wecom")}" class="wecom-otp-login-btn-icon">
						<span>${wecom.t("login", "Login")}</span>
					</span>
				</button>
			</div>
			<div class="wecom-otp-hint">${wecom.t("otp_hint", "Verification code will be sent to your WeCom app.")}</div>
			<div id="wecom_otp_status" class="wecom-otp-status" style="display:none;"></div>
		</div>
	`);

	if (modeTabs) {
		modeTabs.style.display = showToggle ? "flex" : "none";
		wecom.bind_mode_tabs();
	}

	wecom.set_wecom_login_mode(defaultMode);

	const emailInput = document.getElementById("wecom_otp_email");
	const codeInput = document.getElementById("wecom_otp_code");
	const sendBtn = document.getElementById("wecom_otp_send_btn");
	const loginBtn = document.getElementById("wecom_otp_login_btn");
	const statusEl = document.getElementById("wecom_otp_status");
	const codeGroup = otpView.querySelector(".wecom-otp-code-group");
	const otpHeading = otpView.querySelector(".wecom-otp-heading");
	const loginBtnContent = loginBtn?.querySelector(".wecom-otp-login-btn-content");
	const loginBtnIcon = loginBtn?.querySelector(".wecom-otp-login-btn-icon");
	if (!emailInput || !codeInput || !sendBtn || !loginBtn) return;
	let countdown = 0;
	let countdownTimer = null;

	function applyOtpInlineStyles() {
		if (otpHeading) {
			Object.assign(otpHeading.style, {
				display: showToggle ? "none" : "flex",
				alignItems: "center",
				justifyContent: "center",
				gap: "8px",
				marginBottom: "14px",
				color: "var(--text-color, #36414c)",
				fontSize: "14px",
				fontWeight: "600",
			});
		}

		const headingIcon = otpHeading?.querySelector(".wecom-otp-heading-icon");
		if (headingIcon) {
			Object.assign(headingIcon.style, {
				width: "18px",
				height: "18px",
				flex: "0 0 auto",
			});
		}

		if (codeGroup) {
			Object.assign(codeGroup.style, {
				display: "flex",
				alignItems: "center",
				gap: "8px",
				padding: "6px 8px 6px 12px",
				borderRadius: "8px",
				background: "var(--control-bg, #f3f5f7)",
			});
		}

		Object.assign(codeInput.style, {
			flex: "1 1 auto",
			width: "100%",
			marginBottom: "0",
			padding: "4px 0",
			border: "0",
			borderRadius: "0",
			background: "transparent",
			boxShadow: "none",
		});

		Object.assign(sendBtn.style, {
			flex: "0 0 auto",
			height: "32px",
			minWidth: "96px",
			padding: "0 12px",
			border: "0",
			borderRadius: "999px",
			background: "var(--card-bg, #fff)",
			color: "var(--text-muted, #6c7680)",
			fontSize: "12px",
			fontWeight: "600",
			lineHeight: "1",
			whiteSpace: "nowrap",
			boxShadow: "inset 0 0 0 1px var(--border-color, #d1d8dd)",
		});

		if (loginBtnContent) {
			Object.assign(loginBtnContent.style, {
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
				gap: "8px",
			});
		}

		if (loginBtnIcon) {
			Object.assign(loginBtnIcon.style, {
				width: "16px",
				height: "16px",
				flex: "0 0 auto",
			});
		}
	}

	function syncSendButtonStyle() {
		if (sendBtn.disabled) {
			sendBtn.style.background = "var(--card-bg, #fff)";
			sendBtn.style.color = "var(--text-light, #8d99a6)";
			sendBtn.style.opacity = "0.7";
			sendBtn.style.cursor = "not-allowed";
			return;
		}

		sendBtn.style.background = "var(--card-bg, #fff)";
		sendBtn.style.color = "var(--text-muted, #6c7680)";
		sendBtn.style.opacity = "1";
		sendBtn.style.cursor = "pointer";
	}

	applyOtpInlineStyles();
	syncSendButtonStyle();

	function showStatus(message, type) {
		if (!statusEl) return;
		statusEl.textContent = message;
		statusEl.className = "wecom-otp-status" + (type ? ` is-${type}` : "");
		statusEl.style.display = message ? "" : "none";
	}

	function startCountdown(seconds) {
		countdown = seconds;
		sendBtn.disabled = true;
		syncSendButtonStyle();
		if (countdownTimer) clearInterval(countdownTimer);
		sendBtn.textContent = `${countdown}s`;
		countdownTimer = setInterval(() => {
			countdown -= 1;
			if (countdown <= 0) {
				clearInterval(countdownTimer);
				countdownTimer = null;
				sendBtn.disabled = false;
				sendBtn.textContent = wecom.t("send_code", "Send Code");
				syncSendButtonStyle();
				return;
			}
			sendBtn.textContent = `${countdown}s`;
		}, 1000);
	}

	sendBtn.addEventListener("click", () => {
		const email = (emailInput.value || "").trim();
		if (!email) {
			showStatus(wecom.t("email_or_mobile_required", "Email or mobile number is required"), "error");
			emailInput.focus();
			return;
		}
		showStatus("", "");
		sendBtn.disabled = true;
		syncSendButtonStyle();
		frappe.call({
			method: "wecom.wecom_login_otp.send_wecom_login_otp",
			type: "POST",
			args: { email },
			callback(r) {
				if (r.message && r.message.message) {
					showStatus(r.message.message, "success");
					startCountdown(60);
					codeInput.focus();
				} else {
					sendBtn.disabled = false;
					syncSendButtonStyle();
				}
			},
			error() {
				sendBtn.disabled = false;
				syncSendButtonStyle();
			},
		});
	});

	loginBtn.addEventListener("click", () => {
		const email = (emailInput.value || "").trim();
		const otp = (codeInput.value || "").trim();
		if (!email || !otp) {
			showStatus(
				wecom.t("email_or_mobile_and_verification_code_required", "Email or mobile number and verification code are required"),
				"error"
			);
			return;
		}
		showStatus("", "");
		loginBtn.disabled = true;
		frappe.call({
			method: "wecom.wecom_login_otp.verify_wecom_login_otp",
			type: "POST",
			args: { email, otp, redirect: redirectTo },
			callback(r) {
				if (r.message && r.message.redirect_to) {
					window.location.href = r.message.redirect_to;
				} else {
					loginBtn.disabled = false;
				}
			},
			error() {
				loginBtn.disabled = false;
			},
		});
	});

	codeInput.addEventListener("keydown", (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			loginBtn.click();
		}
	});
}

wecom.init = function () {
	if (!wecom.config.is_valid && !wecom.config.developer_mode) return;
	frappe.call({
		method: "wecom.api.get_public_jssdk_config",
		args: {
			url: String(window.location.href || "").split("#")[0],
			js_api_list: JSON.stringify(wecom.get_auto_register_js_api_list()),
		},
		callback: function (r) {
			if (r.message) {
				wecom.jssdk_config = r.message;
			}
		}
	})
}


wecom.register = function () {
	if (wecom.jssdk_config || wecom.config.developer_mode) {
		const jsApiList = Array.isArray(wecom.jssdk_config?.jsApiList) && wecom.jssdk_config.jsApiList.length
			? wecom.jssdk_config.jsApiList
			: wecom.get_auto_register_js_api_list();
		wecom.ww.register({
			debug: false,
			corpId: wecom.config.corpid,
			agentId: wecom.config.agentid,
			jsApiList,
			getConfigSignature: (url) => {
				return new Promise((resolve, reject) => {
					frappe.call({
						method: "wecom.api.get_config_signature",
						args: { url: String(url || "").split("#")[0] },
						callback: function (r) {
							if (r.message) {
								resolve(r.message);
							} else {
								reject(new Error(__("Getting Signature Failed")));
							}
						}
					});
				});
			},
			onConfigSuccess: () => {},
			onConfigFail: () => {},
		});
	}
}
